<template>
<div class="chapter">
<div class="inner_page">
<div class="cover">
<img alt="Cover: Perma Red, A NOVEL by Debra Magpie Earling" epub:type="cover" id="cover_image" role="doc-cover" src="images/9781639550647.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?440589f2